import { get, post } from 'utils/http';
import { YEARLY_REPORT_URL } from 'utils/apiRouting';

export async function startYearlyReport(year) {
  return post(`${YEARLY_REPORT_URL}/${year}`);
}

export async function getYearlyReportJob(jobId) {
  return get(`${YEARLY_REPORT_URL}/jobs/${jobId}`);
}

export async function getLastYearlyReportJob(year) {
  return get(`${YEARLY_REPORT_URL}/last-job/${year}`);
}

export async function getYearlyReport(year) {
  return get(`${YEARLY_REPORT_URL}/${year}`);
}
